import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-turnRise",
  "use": "icon-turnRise-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-turnRise\">\n<path d=\"M3 4.5L7 0L11 4.5H3Z\" fill=\"#1EC239\" />\n<path d=\"M7 4V6C7 7.10457 6.10457 8 5 8H0\" stroke=\"#1EC239\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol